import React, { useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import Popover from "@mui/material/Popover";

interface IBreadCrumb {
  listPath?: Array<string>;
  preCrumb?: IPreCrumb;
}
interface IPreCrumb {
  text: string;
  link: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 260,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    pointerEvents: "auto",
    borderRadius: "0px",
    backgroundColor: "#323232 !important",
    width: 200,
  },
  button: {
    backgroundColor: "inherit !important",
    color: "white",
    border: "none",
    borderBottom: "1px solid black",
    fontWeight: 600,
    "&:hover": {
      color: "#fbe702",
    },
  },
  link: {
    color: "white",
    "&:hover": {
      color: "#fbe702",
    },
    textDecoration: "none",
  },
}));

const LinkRouter = (props: any) => <Link {...props} component={RouterLink} />;

const Breadcrumb = (props: IBreadCrumb) => {
  const { listPath, preCrumb } = props;
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const location = useLocation();
  const { t } = useTranslation("shared");
  const pathnames = location.pathname.split("/").filter((x: any) => x);
  const [open, setOpen] = React.useState(false);

  const clickOnLinkPopover = (e: any) => {
    setAnchorEl(e.currentTarget);
    setOpen(true);
  };

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <LinkRouter color="inherit" to={`/documents`}>
        {t("breadcrumb.home")}
      </LinkRouter>
      {preCrumb && (
        <LinkRouter color="inherit" to={preCrumb.link}>
          {t(("navmenu." + preCrumb.text) as any)}
        </LinkRouter>
      )}

      {pathnames.map((value: any, index: any) => {
        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        return last ? (
          <div key={index}>
            {listPath ? (
              <div>
                <LinkRouter
                  color="inherit"
                  key={to}
                  onClick={clickOnLinkPopover}
                >
                  {t(("breadcrumb." + to) as any)}
                </LinkRouter>
                <PopoverBreadCrumb
                  open={open}
                  setOpen={setOpen}
                  listPath={listPath}
                  anchorEl={anchorEl}
                />
              </div>
            ) : (
              <Typography color="textPrimary" key={to}>
                {t(("breadcrumb." + to) as any)}
              </Typography>
            )}
          </div>
        ) : (
          <LinkRouter color="inherit" to={to} key={to}>
            {t(("breadcrumb." + to) as any)}
          </LinkRouter>
        );
      })}
    </Breadcrumbs>
  );
};

const PopoverBreadCrumb = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation("shared");
  const { anchorEl, listPath, setOpen, open } = props;
  return (
    <Popover
      classes={{
        paper: classes.paper,
      }}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      disableRestoreFocus
      onClose={() => setOpen(false)}
    >
      {listPath.map((item: any, i: number) => {
        return (
          <button className={classes.button} key={i}>
            <LinkRouter
              className={classes.link}
              onClick={() => setOpen(false)}
              color="inherit"
              to={item}
              key={item}
            >
              {t(("breadcrumb." + item) as any)}
            </LinkRouter>
          </button>
        );
      })}
    </Popover>
  );
};
export default Breadcrumb;
